import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { FormattedMessage, IntlProvider } from "react-intl"; // Backup Way to Convert
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import RetailerCss from "../../public/css/retailer/retailer_style.css";
import RetailerHeader from "../retailer/RetailerHeader";
import RetailerSideMenu from "../retailer/RetailerSideMenu";
import Footer from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import dateformatter from "../helpers/dateformatter";
import DateRangeFilter from "../common/DateRangeFilter";
import { Pagination } from "react-bootstrap";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");

const orderStatusMapping = {
  1: "Order Placed",
  2: "Prescription Verified",
  3: "Processed",
  4: "Shipped",
  5: "Delivered",
  6: "Cancelled",
};

export default class Retailertransactionhistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      startDate: "",
      endDate: "",
      currentPage: 1,
      perPage: 10,
      totalPages: 1,
      totalItems: 0,
    };
    this.clearFilters = this.clearFilters.bind(this);
  }

  // To get detais after first render

  componentDidMount = () => {
    let userData = ls.get("retuserObj");
    // let userData = reactLocalStorage.getObject("retuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.retailer_id,
          retailerCurrency: userData.currency,
        });
        this.forceUpdate();
      }
    } else {
      window.location.href = "/retailer/login";
    }
    this.retailerOrderDetails(userData.retailer_id, "5", 1);
  };

  // Clear filter
  clearFilters = () => {
    window.location.reload(); // full page reload
  };
  // order details list

  retailerOrderDetails = (retailerId, status, page) => {
    let startDate = "";
    let endDate = "";
    let finalorderarray = [];
    let currentPage = page || this.state.currentPage;

    startDate = this.state.startDate;
    endDate = this.state.endDate;

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/orderProcess/retailerOrdersSearch",
      {
        retailer_id: retailerId,
        start_date: startDate,
        end_date: endDate,
        status: status,
        page: currentPage,
        limit: this.state.perPage,
      }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          if (Object.keys(response.data.data).length > 0) {
            const retailerFinalOrderMedicineDetailsView = response.data.data.map(
              (finalLoadedData, num) => {
                //console.log("num---------", finalLoadedData)
                return (
                  <tr>
                    <td>{(currentPage - 1) * this.state.perPage + num + 1}</td>
                    <td>
                      {finalLoadedData?.delivery_address?.name
                        .charAt(0)
                        .toUpperCase() +
                        finalLoadedData?.delivery_address?.name.slice(1)}{" "}
                      <h6>{finalLoadedData?.delivery_address?.mobile_no}</h6>
                    </td>
                    <td>{finalLoadedData.id}</td>
                    <td>
                      {dateformatter.asianDateFormat(
                        finalLoadedData.order_date
                      )}
                    </td>

                    <td class="presc_field">
                      {finalLoadedData?.prescriptionDetails?.length > 0
                        ? finalLoadedData.prescriptionDetails.map(
                            (prescription, index) =>
                              prescription.medical_document?.map(
                                (presImages, num) => (
                                  <a
                                    key={`${index}-${num}`}
                                    href={presImages ? presImages : ""}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      className="presc_img"
                                      src="../images/retailer/Invoice.svg"
                                      alt="Prescription"
                                    />
                                  </a>
                                )
                              )
                          )
                        : "--"}

                      {/* {finalLoadedData?.prescriptionDetails
                        ? finalLoadedData?.prescriptionDetails?.medical_document.map(
                            (presImages, num) => {
                              return (
                                <a
                                  href={
                                    presImages
                                      ? Constant.imgurl + presImages
                                      : ""
                                  }
                                  target="_blank"
                                >
                                  <img
                                    class="presc_img"
                                    src="../images/retailer/Invoice.svg"
                                  />
                                </a>
                              );
                            }
                          )
                        : "--"} */}
                    </td>
                    <td>
                      {Object.keys(finalLoadedData?.orderProcessing).length}
                    </td>
                    <td>
                      {finalLoadedData?.payment_method
                        ? finalLoadedData.payment_method.toUpperCase()
                        : finalLoadedData?.payment_mode
                        ? finalLoadedData.payment_mode.toUpperCase()
                        : "--"}
                    </td>
                    <td>
                      {orderStatusMapping[finalLoadedData?.order_status] ||
                        "--"}
                    </td>
                    <td>
                      {finalLoadedData?.delivery_date
                        ? dateformatter.asianDateFormat(
                            finalLoadedData.delivery_date
                          )
                        : "--"}
                    </td>

                    <td>
                      {finalLoadedData.total_paid != null
                        ? this.state.retailerCurrency
                        : ""}{" "}
                      {finalLoadedData.total_paid != null
                        ? Number(
                            parseFloat(finalLoadedData.total_paid).toFixed(2)
                          )
                        : "--"}
                    </td>
                    <td>
                      {finalLoadedData?.invoice ? (
                        <a
                          href={
                            finalLoadedData?.invoice
                              ? //Constant.imgurl +
                                finalLoadedData?.invoice
                              : ""
                          }
                          target="_blank"
                        >
                          <img
                            class="presc_img"
                            src="../images/retailer/RxFile.svg"
                          />
                        </a>
                      ) : (
                        "--"
                      )}
                    </td>
                  </tr>
                );
              }
            );
            this.state.retailerFinalOrderMedicineDetailsView = retailerFinalOrderMedicineDetailsView;
            this.state.finalorderarray = finalorderarray;
          } else {
            this.state.retailerFinalOrderMedicineDetailsView = "";
          }
          this.state.totalCost = response.data.TotalOnlineSale || 0;
          this.state.currentPage = response.data.current_page || currentPage;
          this.state.totalPages = response.data.total_pages || 1;
          this.state.totalItems = response.data.total_items || 0;
          this.forceUpdate();
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //start date selection

  startDate = (event) => {
    let startDate = event.target.value;
    // Clearing the input hands back "", which moment would turn into
    // "Invalid date" and send straight to the search API.
    this.state.startDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    this.forceUpdate();
  };

  //  end date selection
  endDate = (event) => {
    let endDate = event.target.value;
    this.state.endDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";
    this.forceUpdate();
  };

  //  For showing order by date
  showOrderbyDates = () => {
    let start_date = $("#start_date").val();
    let end_date = $("#end_date").val();
    if (start_date <= end_date) {
      if (start_date != "" && end_date != "") {
        this.retailerOrderDetails(this.state.retailerId, 5, 1);
      } else {
        toast.error("Please select dates");
      }
    } else {
      toast.error("from date cannot be greater than to date");
    }
  };

  //  page change
  handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > this.state.totalPages) {
      return;
    }
    this.retailerOrderDetails(this.state.retailerId, "5", pageNumber);
  };

  render() {
    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section id="Pharmacy_dashboard">
          <div class="col-lg-10 col-md-10 Pharma_Content">
            <section class="retailer_section">
              <div class="container-fluid">
                <div class="row col-md-12 trans_history">
                  <div class="col-lg-7 col-md-12 p_schedule no_padding">
                    <DateRangeFilter
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      onStartDateChange={this.startDate}
                      onEndDateChange={this.endDate}
                      onFind={this.showOrderbyDates}
                      onClear={this.clearFilters}
                    />
                  </div>
                  <div class="col-lg-5 col-md-12 no_padding">
                    <nav class="p_nav">
                      <div
                        class="nav nav-tabs nav-fill"
                        id="nav-tab"
                        role="tablist"
                      >
                        <a
                          class="nav-item nav-link active"
                          id="online-tab"
                          data-toggle="tab"
                          href="#online_home"
                          role="tab"
                          aria-controls="online_home"
                          aria-selected="true"
                        >
                          Total Online Sale
                          <p>
                            {Constant.currency}{" "}
                            {this.state.totalCost
                              ? parseFloat(this.state.totalCost)
                                  .toFixed(2)
                                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                              : "0.00"}
                          </p>
                        </a>
                      </div>
                    </nav>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="tab-content tab_side" id="nav-tabContent">
                      <div
                        class="tab-pane trans_tab_pane fade show active"
                        id="online_home"
                        role="tabpanel"
                        aria-labelledby="online-tab"
                      >
                        <div class="container-fluid">
                          <div class="row">
                            <div class="col-md-12 no_padding">
                              <div class="tableFixHead">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>No</th>
                                      <th>Customer</th>
                                      <th>Order ID</th>
                                      <th>Order Date</th>
                                      <th>Prescription</th>
                                      <th>Items</th>
                                      <th>Payment Type</th>
                                      <th>Delivery Status</th>
                                      <th>Delivery Date & Time</th>
                                      <th>Invoice Amount</th>
                                      <th>Invoice</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state
                                      .retailerFinalOrderMedicineDetailsView ? (
                                      this.state
                                        .retailerFinalOrderMedicineDetailsView
                                    ) : (
                                      <React.Fragment>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>No Order Found</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>{" "}
                                      </React.Fragment>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              {this.state.totalPages > 1 && (
                                <div class="trans_pagination">
                                  <p class="trans_count">
                                    Showing{" "}
                                    {(this.state.currentPage - 1) *
                                      this.state.perPage +
                                      1}{" "}
                                    to{" "}
                                    {Math.min(
                                      this.state.currentPage *
                                        this.state.perPage,
                                      this.state.totalItems
                                    )}{" "}
                                    of {this.state.totalItems} transactions
                                  </p>
                                  <Pagination>
                                    <Pagination.First
                                      onClick={() => this.handlePageChange(1)}
                                      disabled={this.state.currentPage === 1}
                                    />
                                    <Pagination.Prev
                                      onClick={() =>
                                        this.handlePageChange(
                                          this.state.currentPage - 1
                                        )
                                      }
                                      disabled={this.state.currentPage === 1}
                                    />
                                    {[...Array(this.state.totalPages)].map(
                                      (_, index) => {
                                        const pageNum = index + 1;
                                        if (
                                          pageNum === 1 ||
                                          pageNum === this.state.totalPages ||
                                          (pageNum >= this.state.currentPage - 2 &&
                                            pageNum <= this.state.currentPage + 2)
                                        ) {
                                          return (
                                            <Pagination.Item
                                              key={pageNum}
                                              active={
                                                pageNum === this.state.currentPage
                                              }
                                              onClick={() =>
                                                this.handlePageChange(pageNum)
                                              }
                                            >
                                              {pageNum}
                                            </Pagination.Item>
                                          );
                                        } else if (
                                          pageNum === this.state.currentPage - 3 ||
                                          pageNum === this.state.currentPage + 3
                                        ) {
                                          return (
                                            <Pagination.Ellipsis key={pageNum} />
                                          );
                                        }
                                        return null;
                                      }
                                    )}
                                    <Pagination.Next
                                      onClick={() =>
                                        this.handlePageChange(
                                          this.state.currentPage + 1
                                        )
                                      }
                                      disabled={
                                        this.state.currentPage ===
                                        this.state.totalPages
                                      }
                                    />
                                    <Pagination.Last
                                      onClick={() =>
                                        this.handlePageChange(
                                          this.state.totalPages
                                        )
                                      }
                                      disabled={
                                        this.state.currentPage ===
                                        this.state.totalPages
                                      }
                                    />
                                  </Pagination>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <ToastContainer />
          </div>
        </section>
      </main>
    );
  }
}
